<template>
  <div class="content-nav">
    <div class="card">
      <div class="item-card rounded-10 border-1" :class="{ act: nav_id === 1 }" @click="nav_id = 1">
        <img v-if="nav_id === 1" src="@/assets/img/chat/icon-1-bg.png" style="width: 32px; height: 32px;" alt="">
        <img v-else src="@/assets/img/chat/icon-1.png" style="width: 32px; height: 32px;" alt="">
        院校分析
      </div>
      <div class="item-card rounded-10 border-1" :class="{ act: nav_id === 2 }" @click="nav_id = 2">
        <img v-if="nav_id === 2" src="@/assets/img/chat/icon-2-bg.png" style="width: 32px; height: 32px;" alt="">
        <img v-else src="@/assets/img/chat/icon-2.png" style="width: 32px; height: 32px;" alt="">
        专业分析
      </div>
      <div class="item-card rounded-10 border-1" :class="{ act: nav_id === 3 }" @click="nav_id = 3">
        <img v-if="nav_id === 3" src="@/assets/img/chat/icon-3-bg.png" style="width: 32px; height: 32px;" alt="">
        <img v-else src="@/assets/img/chat/icon-3.png" style="width: 32px; height: 32px;" alt="">
        院校对比
      </div>
      <div class="item-card rounded-10 border-1" :class="{ act: nav_id === 4 }" @click="nav_id = 4">
        <img v-if="nav_id === 4" src="@/assets/img/chat/icon-4-bg.png" style="width: 32px; height: 32px;" alt="">
        <img v-else src="@/assets/img/chat/icon-4.png" style="width: 32px; height: 32px;" alt="">
        专业对比
      </div>
      <div class="item-card rounded-10 border-1" :class="{ act: nav_id === 5 }" @click="nav_id = 5">
        <img v-if="nav_id === 5" src="@/assets/img/chat/icon-5-bg.png" style="width: 32px; height: 32px;" alt="">
        <img v-else src="@/assets/img/chat/icon-5.png" style="width: 32px; height: 32px;" alt="">
        志愿分析
      </div>
    </div>
    <div class="search-item ">
      <transition name="fade">
        <div :key="nav_id" class="card-content">
          <div class="search-school" v-if="nav_id == 0">
            <question-list @getChat="getChat"></question-list>
          </div>
          <div class="search-school" v-if="nav_id == 1">
            <search-school @getChat="getChat"></search-school>
          </div>
          <div class="search-school" v-if="nav_id == 2">
            <search-specialty @getChat="getChat"></search-specialty>
          </div>
          <div class="search-school" v-if="nav_id == 3">
            <contrast-school @getChat="getChat"></contrast-school>
          </div>
          <div class="search-school" v-if="nav_id == 4">
            <contrast-specialty @getChat="getChat"></contrast-specialty>
          </div>
          <div class="search-school" v-if="nav_id == 5">
            <report-table @getChat="getChat"></report-table>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import SearchSchool from './../../search/SearchSchool'
import SearchSpecialty from './../../search/SearchSpecialty'
import ContrastSchool from './../../contrast/ContrastSchool'
import ContrastSpecialty from './../../contrast/ContrastSpecialty'
import QuestionList from './../../question'
import ReportTable from './../../report/index.vue'
export default {
  name: '',
  props:['nav_refresh'],
  data() {
    return {
      nav_id: 0,
    };
  },
  components: {
    SearchSchool,
    SearchSpecialty,
    ContrastSchool,
    ContrastSpecialty,
    QuestionList,
    ReportTable,
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getChat(e) {
      this.$emit('sendChat', e)
    },
  },
};
</script>

<style scoped lang='less'>
.content-nav {
  width: 1200px;
  margin: auto;
  margin-top: 20px;

  .card {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 34px;
    font-size: 22px;

    .item-card {
      width: 220px;
      height: 55px;
      line-height: 55px;
      transition: transform 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 18px;
      border-radius: 101px;
    }

    .item-card:hover {
      cursor: pointer;
      transform: translateY(-5px);
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    }

    .act {
      color: white;
      background: #008BFF;
      border: 1px solid #008BFF;
    }

    .search-school {
      transition: transform 0.3s ease;
    }
  }
}
</style>
